import { createFileRoute } from '@tanstack/react-router';
import { StaticPage } from '../components/static/StaticPage';
import { staticHead } from '../lib/seo';
import { getStaticPage } from '../lib/static-content';

export const Route = createFileRoute('/disclaimer')({
  head: () => {
    const p = getStaticPage('disclaimer');
    return staticHead({ pathname: '/disclaimer', title: p.title, description: p.metaDescription });
  },
  component: () => <StaticPage slug="disclaimer" />,
});
